module.exports = __webpack_public_path__ + "static/img/silhouette_08.631fbea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_08.png
// module id = axzh
// module chunks = 0